import { createElement } from "./_dom";
import { computePosition, autoUpdate, offset } from '@floating-ui/dom';

const showDelay = 250; // ms, little bit less than OS default 300ms
let initialized;
let tooltip;
let popperCleanup;
let timeoutId = 0;
let selectors = "[data-tooltip]";
let lastElement;

function hide() {
	if (lastElement) {
		tooltip.remove();
		tooltip = null;
		popperCleanup();
		popperCleanup = null;
		lastElement = null;
	}
}

function onPointerOrMouseOut({ type, target: element, relatedTarget }) {
	if (!relatedTarget || !element.contains(relatedTarget)) {
		element.removeEventListener(type, onPointerOrMouseOut);
		hide();
	}
}

const tooltipPopperOptions = {
	placement: "bottom",
	middleware: [offset(4)]
};

function show(element, textOrNode, isTouch, hideEventType) {
	let content;
	if (typeof textOrNode === "string") {
		content = textOrNode.split("\r\n");
		for (let i = 1; i < content.length; i += 2)
			content.splice(i, 0, document.createElement("br"));
	} else {
		content = [textOrNode];
	}
	lastElement = element;
	tooltip = createElement("div", { id: `v3-tooltip-${new Date().valueOf()}`, class: "v3-tooltip" }, ...content);
	document.body.appendChild(tooltip);
	popperCleanup = autoUpdate(element, tooltip, () => computePosition(element, tooltip, { ...tooltipPopperOptions, placement: isTouch ? "top" : "bottom" }).then(({ x, y }) => { tooltip.style.left = `${x}px`; tooltip.style.top = `${y}px`; }));

	if (hideEventType) {
		element.addEventListener(hideEventType, onPointerOrMouseOut);
	}
}

function checkIfShow(target, isTouch, hideEventType) {
	const element = target?.closest(selectors);
	if (element && element != lastElement) {
		let text = element.dataset.tooltip;
		if (text == null) {
			text = element.getAttribute("title");
			if (text != null) {
				element.removeAttribute("title");
				element.dataset.tooltip = text;
				if (text && !element.ariaDescription)
					element.ariaDescription = text;
			}
		}
		if (text) {
			hide(); // previous, if any
			show(element, text, isTouch, hideEventType);
		}
	} else {
		hide();
	}
}

function addSelector(selector) {
	if (selectors.split(",").indexOf(selector) < 0) {
		selectors += `,${selector}`;
	}
}

function onPointerDown(event) {
	clearTimeout(timeoutId);
	var isTouch = event instanceof PointerEvent && event.pointerType != "mouse";
	timeoutId = setTimeout(checkIfShow, showDelay, event.target, isTouch);
}

function onPointerUp() {
	clearTimeout(timeoutId);
	timeoutId = 0;
	hide();
}

function onPointerMove({ target, pointerType }) {
	clearTimeout(timeoutId);
	timeoutId = setTimeout(checkIfShow, showDelay, target, pointerType != "mouse", "pointerout");
}

function onMouseMove({ target }) {
	clearTimeout(timeoutId);
	timeoutId = setTimeout(checkIfShow, showDelay, target, false, "mouseout");
}

// title attribute on input controls is used to display form validation message. 
// do not mess with it on inputs / selects
function init(context, selector = "[title]:not(input):not(select):not(textarea)") {
	context = document;
	if (!initialized) {
		initialized = true;
		if (window.PointerEvent) {
			context.addEventListener("pointerdown", onPointerDown, { passive: true });
			context.addEventListener("pointermove", onPointerMove, { passive: true });
			context.addEventListener("pointerup", onPointerUp, { passive: true });
			context.addEventListener("pointercancel", onPointerUp, { passive: true });
		} else if ("ontouchstart" in window) {
			context.addEventListener("touchstart", onPointerDown, { passive: true });
			context.addEventListener("touchend", onPointerUp, { passive: true });
			context.addEventListener("touchcancel", onPointerUp, { passive: true });
		} else {
			context.addEventListener("mousemove", onMouseMove, { passive: true });
		}
	}
	addSelector(selector);
}

export { init };